const youtubeHosts = new Set([
  'youtube.com',
  'www.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com'
]);
export const youtubePermissions =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

export function getYoutubeEmbedUrl(source = '') {
  try {
    const url = new URL(String(source).trim().replace(/^\/\//, 'https://'));
    if (
      !['http:', 'https:'].includes(url.protocol) ||
      url.username ||
      url.password ||
      url.port ||
      !youtubeHosts.has(url.hostname) ||
      !/^\/embed(?:\/[a-z0-9_-]+)?\/?$/i.test(url.pathname)
    )
      return '';
    url.protocol = 'https:';
    return url.href;
  } catch {
    return '';
  }
}

export function getContentEmbedType(source = '', className = '') {
  if (getYoutubeEmbedUrl(source)) return 'youtube';
  if (
    String(className).split(/\s+/).includes('content-pdf-preview__frame') &&
    (/^data:application\/pdf;base64,[a-z0-9+/=\s]+$/i.test(source) ||
      /^https?:\/\/[^/?#]+\/uploads\/[a-f0-9-]+\.pdf(?:[?#].*)?$/i.test(source))
  )
    return 'pdf';
  return '';
}

export function normalizeContentIframe(element) {
  const type = getContentEmbedType(element.getAttribute('src') || '', element.className);
  if (!type) return '';
  element.removeAttribute('sandbox');
  if (type === 'youtube') {
    element.src = getYoutubeEmbedUrl(element.getAttribute('src'));
    element.classList.add('content-video-frame');
    element.setAttribute('allow', youtubePermissions);
    element.setAttribute('allowfullscreen', '');
    element.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    element.setAttribute('loading', 'lazy');
    if (!element.title) element.title = 'YouTube video';
    const width = Number(element.getAttribute('width'));
    const height = Number(element.getAttribute('height'));
    if (!element.style.width) element.style.width = width > 0 && width <= 4096 ? `${width}px` : '100%';
    element.style.height = 'auto';
    element.style.aspectRatio =
      width > 0 && height > 0 && width <= 4096 && height <= 4096 ? `${width} / ${height}` : '16 / 9';
  }
  return type;
}

export function sanitizePdfPreviewStyle(value = '', property) {
  const match = new RegExp(`^\\s*${property}\\s*:\\s*(\\d{1,4})px\\s*;?\\s*$`, 'i').exec(String(value || ''));
  if (!match) return '';
  const dimension = Number(match[1]);
  const limits = property === 'width' ? [320, 1920] : [100, 1200];
  return dimension >= limits[0] && dimension <= limits[1] ? `${property}: ${dimension}px` : '';
}
